export const ListQueryKey = 'activityRoomRewardConfigs';
export const DetailQueryKey = 'activityRoomRewardConfig';
export const Urls = {
  selectUrl: '/RoomReward/list',
  updateUrl: '/RoomReward/update',
  deleteUrl: '/RoomReward/delete',
  createUrl: '/RoomReward/create',
  detailUrl: '/RoomReward/detail'
};